import Draggable from 'react-draggable'
import { useState } from 'react'

function DraggableSlider(): React.ReactElement {
  const [position, setPosition] = useState({ x: 0, y: 100 })
  const [containerPoistion, setContainerPosition] = useState({ x: 0, y: 0 })

  let element: HTMLDivElement | null = null
  function updatePoition(): void {
    if (!element) return

    if (position.x === element.getBoundingClientRect().x && position.y === element.getBoundingClientRect().y) return

    setPosition({
      x: element.getBoundingClientRect().x - containerPoistion.x,
      y: 100 - Math.round(((element.getBoundingClientRect().y - containerPoistion.y) / 336) * 100),
    })
  }

  return (
    <div
      className="z-10 container w-80 min-h-96 max-h-96 h-96 pb-12"
      ref={(el) => {
        if (
          !el ||
          (containerPoistion.x === el.getBoundingClientRect().x && containerPoistion.y === el.getBoundingClientRect().y)
        ) {
          return
        }
        setContainerPosition({ x: el.getBoundingClientRect().x, y: el.getBoundingClientRect().y })
      }}
    >
      <Draggable bounds="parent" defaultPosition={{ x: 0, y: 0 }} onDrag={updatePoition}>
        <div
          className="flex h-12 w-full rounded-full"
          id="1"
          ref={(el) => {
            if (!el) return
            element = el
          }}
        >
          {' '}
          <div className="flex ml-6">
            <p className="mt-auto -mb-3">-----------------</p>
          </div>
          <div className="flex w-14 h-10 mt-6 bg-green-checkmark border-2 -ml-2 rounded-2">
            <p className="m-auto text-xl font-semibold">{position.y}</p>
          </div>
        </div>
      </Draggable>
      <div className=" w-4 bg-black h-full ml-5" />
    </div>
  )
}
export default DraggableSlider
